import React, { useContext, useEffect, useState } from 'react'
import ProfessionalAccountUpdates from './ProfessionalAccountUpdates'
import { SlArrowDown, SlArrowUp } from 'react-icons/sl';
import { GrInProgress } from 'react-icons/gr';
import { GoTriangleRight } from 'react-icons/go';
import { InfoIcon, Check, X, Clock } from 'lucide-react';
import { Context } from 'Context/Context';
import { deleteUpdateOnProfAccApi } from 'Constants';
import ChangeOrg from './ChangeOrg';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

export function VerificationTimeline({ submittedAt, isDenied }) {
  const steps = [
    {
      key: "submitted",
      label: "Submitted",
      sublabel: submittedAt ? moment(submittedAt).format("MMM D") : "",
      state: "done",
    },
    {
      key: "review",
      label: isDenied ? "Reviewed" : "Under review",
      sublabel: isDenied ? "" : "Est. 1-2 days",
      state: isDenied ? "done" : "current",
    },
    {
      key: "final",
      label: isDenied ? "Not approved" : "Live on profile",
      sublabel: isDenied ? "" : "Pending",
      state: isDenied ? "denied" : "pending",
    },
  ];

  const circleClass = (state) => {
    if (state === "done" || state === "current") return "bg-tan text-ivory";
    if (state === "denied") return "border-2 border-red-600 text-red-600 bg-white";
    return "border-2 border-gray-300 text-gray-400 bg-white";
  };
  const lineClass = (fromDone) => (fromDone ? "bg-tan" : "bg-gray-200");
  const labelClass = (state) => {
    if (state === "done" || state === "current") return "text-navy";
    if (state === "denied") return "text-red-600";
    return "text-gray-400";
  };
  const stepIcon = (state) => {
    if (state === "done") return <Check className="w-5 h-5" />;
    if (state === "current") return <Clock className="w-5 h-5" />;
    if (state === "denied") return <X className="w-5 h-5" />;
    return "";
  };

  return (
    <div className="flex items-center w-full mb-4">
      {steps.map((s, i) => (
        <React.Fragment key={s.key}>
          <div className="flex flex-col items-center flex-shrink-0">
            <div className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${circleClass(s.state)}`}>
              {stepIcon(s.state)}
            </div>
            <div className={`mt-1 text-xs font-semibold text-center whitespace-nowrap ${labelClass(s.state)}`}>{s.label}</div>
            {s.sublabel && <div className="text-[11px] text-gray-400">{s.sublabel}</div>}
          </div>
          {i < steps.length - 1 && (
            <div className={`mx-2 h-[2px] flex-1 ${lineClass(s.state === "done")}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

const renderCardValue = (val) => {
  if (Array.isArray(val)) {
    if (val.length === 0) {
      return <span className='italic text-gray-400'>--</span>;
    }
    return <span>{val.join(", ")}</span>;
  }
  if (!val) {
    return <span className='italic text-gray-400'>Not yet set</span>;
  }
  return <span>{val}</span>;
};

function UpdateComparisonCards({ label, labels, updatedUserInfo, changeOrg }) {
  const changedRows = Object.entries(labels).filter(([rowLabel, value]) =>
    updatedUserInfo?.[value] &&
    updatedUserInfo?.[value]?.newValue &&
    (changeOrg === true || (changeOrg === false && value !== "casePref" && value !== "statePref")) &&
    !rowLabel.toLowerCase().includes('pic')
  );

  if (!changedRows.length) return null;

  return (
    <div className='w-full lg:px-6'>
      {label && <div className='font-spectral font-bold text-navy mb-4 border-t border-gray-200 pt-4 mt-2'>{label}</div>}
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 w-full'>
        <div className='rounded-lg border border-gray-200 bg-white p-4'>
          <div className='flex items-center gap-2 text-sm font-semibold text-gray-500 pb-3 mb-3 border-b border-gray-200'>
            <span className='w-2 h-2 rounded-full bg-gray-300' />
            Currently live
          </div>
          {changedRows.map(([rowLabel, value]) => (
            <div key={rowLabel} className='mb-3 last:mb-0'>
              <div className='text-[11px] font-bold uppercase tracking-wide text-gray-400'>{rowLabel}</div>
              <div className='text-sm text-gray-400 mt-1'>{renderCardValue(updatedUserInfo?.[value]?.oldValue)}</div>
            </div>
          ))}
        </div>
        <div className='rounded-lg border border-tan bg-cream p-4'>
          <div className='flex items-center gap-2 text-sm font-semibold text-tanDark pb-3 mb-3 border-b border-tan/40'>
            <Clock className='w-4 h-4 text-tan' />
            Pending approval
          </div>
          {changedRows.map(([rowLabel, value]) => (
            <div key={rowLabel} className='mb-3 last:mb-0'>
              <div className='text-[11px] font-bold uppercase tracking-wide text-tan'>{rowLabel}</div>
              <div className='text-sm font-semibold text-navy mt-1'>{renderCardValue(updatedUserInfo?.[value]?.newValue)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function SeeUpdatesMadeOnAccount({updatesSent, setReRenderData, isDenied, showEditOrPopup, labels, variant = "accordion"}) {
    const [showUpdates, setShowUpdates] = useState(false);
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const navigate = useNavigate();
    const [infoObj, setInfoObj] = useState({
      "title" : "",
      "description" : ""
    });
    useEffect(() => {

            setInfoObj({
              "title" : (isDenied ?

                "Submitted"+(updatesSent?.changeOrg ? " firm change" : "")+" details (Denied approval)"
                :
                "Submitted"+(updatesSent?.changeOrg ? " firm change" : "")+" details (under review)"),
              "description" : (isDenied ?
                (userDetails?.verified ?
                "We could not approve your updates. Review our comments and resubmit"
                :
                "We could not approve your profile. Review our comments and resubmit.")
                :
                "These updates will replace your current profile information once approved.")
            })



    },[])

    const discardUpdates = () => {
      makeApiCallFunc(
          deleteUpdateOnProfAccApi +  updatesSent?._id,
          null,
          (data) => {
              setReRenderData(prev => !prev)
          },
          (data) => console.log(data),
      )
    }

    if (variant === "cards") {
      return (
        <div className='w-full lg:px-6'>
          <VerificationTimeline submittedAt={updatesSent?.created_at} isDenied={isDenied} />
          <UpdateComparisonCards labels={labels} updatedUserInfo={updatesSent?.updatedUserInfo} changeOrg={updatesSent?.changeOrg} />
          {
            updatesSent?.user?.isUserAssistant &&
            <UpdateComparisonCards
              label="Attorney you are acting on behalf of"
              labels={{
                "Attorney's first name" : "firstName",
                "Attorney's last name" : "lastName",
                "Attorney's email" : "email",
                "Attorney's Law Firm Link" : "lawFirmLink",
                "Attorney's linkedin" : "linkedin",
              }}
              updatedUserInfo={updatesSent?.updatedUserInfo?.attorney}
              changeOrg={true}
            />
          }
          <div className='flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 w-full mt-6 text-sm text-gray-500'>
            <div>
              {
                isDenied ?
                <span><b className='text-red-600'>Review message:</b> {updatesSent?.deniedMessage}</span>
                :
                "Need to change something before we review it? You can edit or discard these changes any time before approval."
              }
            </div>
            <div className='flex gap-3 flex-shrink-0'>
              {
                updatesSent?.changeOrg &&
                <div
                className="w-auto px-6 py-2 font-bold text-sm bg-tan hover:bg-tanDark text-ivory rounded flex justify-center items-center cursor-pointer"
                onClick = {()=> window.location.href = "/attorney/profile/5"}>{
                  isDenied ? "Resubmit Firm Details" : "Edit Firm Details"
                }</div>
              }
              {
                !isDenied &&
                <div
                className='cursor-pointer text-red-600 rounded px-6 py-2 text-sm font-bold border border-red-300 bg-white hover:bg-red-50'
                onClick={discardUpdates}>Discard pending changes</div>
              }
            </div>
          </div>
        </div>
      );
    }

  return (
    <div>
        <div className="items-center justify-between flex lg:px-6 flex-col w-full">
          <div className='flex flex-col w-full'>
            <VerificationTimeline submittedAt={updatesSent?.created_at} isDenied={isDenied} />
          <div className='flex  w-full justify-between'>
          <div
            className={"w-full rounded p-4 cursor-pointer flex flex-col justify-between " }
            onClick={() => setShowUpdates(prev => !prev)}
          >
              <div className="text-sm lg:text-md flex items-center font-bold justify-left text-navy font-spectral">
                {
                  infoObj.title
                }

                <GoTriangleRight
                className=
                {
                  'text-[20px] text-tan transition-transform duration-200 ease-in-out'
                  +
                  (showUpdates ? ' rotate-90' : ' rotate-0')
                  }/>
                </div>

          </div>
          {
            updatesSent?.changeOrg &&

          <div className='flex font-normal text-sm w-full  justify-end items-start '>
              <div
              className="w-auto px-[40px] py-[20px]  font-bold h-8 bg-tan hover:bg-tanDark text-ivory rounded  flex justify-center items-center cursor-pointer shadow-xl"
              onClick = {()=> window.location.href = "/attorney/profile/5"}>{
                isDenied ? "Resubmit Firm Details" : "Edit Firm Details"
              }

              </div>
          </div>
          }
          </div>
          </div>
          <div

          >
            {showUpdates && <div className=" w-full bg-cream/60">
              <div className='text-sm lg:ml-10 mb-4 pt-4 text-navy flex items-center'><InfoIcon className='w-4 h-4 mr-2 text-tan'/>
              {infoObj.description}
             </div>
           <hr className='border-gray-200' />
            <ProfessionalAccountUpdates updatesSent={updatesSent} setReRenderData={setReRenderData} isDenied={isDenied} showEditOrPopup={showEditOrPopup}
            labels = {labels}
            />
            </div>}
          </div>
        </div>

    </div>
  )
}

export default SeeUpdatesMadeOnAccount
